import React, { Component } from 'react';
import SideLink from './sidelink';
import AsideDropdown from './asideDropdown';
import { LOCAL_STORAGE } from '../../utils/constants';
import { enableQuicksightDashboard } from '../../config/features';

class Asidebar extends Component {
    state = {
        error: false
    }

    render() {
        let imgIcon = `assets/img/${LOCAL_STORAGE.customerNo}.png`;
        const imgURL = `${process.env.REACT_APP_BASE_URL}/profile_images/${LOCAL_STORAGE.customerLogo}`
        let imgIconWidth;
        switch (LOCAL_STORAGE.customerNo) {
            case 1562:
                imgIcon = `${process.env.REACT_APP_BASE_URL}/profile_images/${LOCAL_STORAGE.customerLogo}`
                imgIconWidth = "100%";
                break;
            case 1568:
                imgIcon = `${process.env.REACT_APP_BASE_URL}/profile_images/${LOCAL_STORAGE.customerLogo}`
                imgIconWidth = "100%";
                break;
            case 1654:
                    imgIcon = `assets/img/${LOCAL_STORAGE.customerNo}.jpeg`;
                    imgIconWidth = "100%";
                    break;
            default:
                imgIcon = "assets/img/logo.png";
                imgIconWidth = "60%";
                break;
        }
        return (
            <React.Fragment>
                <div id="sidebars">
                    <aside id="asidebar" className="sidenav smallSiderbar">
                        <div className="img-thumbnail">
                            {!this.state.error && <img src={ LOCAL_STORAGE?.customerLogo != 'null' ? imgURL : imgIcon} onError={() => { this.setState({ error: true }) }}
                                alt='...'
                                className="sidelogo pt-1" style={{ objectFit: 'contain', width: imgIconWidth || '60%', display: 'block', margin: 'auto' }}
                            />}
                            {this.state.error && <img
                                src="assets/img/logo.png"
                                alt='...'
                                className="sidelogo pt-1" style={{ objectFit: 'contain', width: imgIconWidth || '60%', display: 'block', margin: 'auto' }}
                            />}
                        </div>
                        {LOCAL_STORAGE.role === 'vendor' ?
                            <>
                                <SideLink imgLink="assets/svg/jobcards.svg" linkTo="jobcard" linkName='Jobcard' />
                            </>
                            :
                            <>
                                {enableQuicksightDashboard ? <SideLink Exact={true} imgLink='assets/svg/dashboard.svg' linkTo='/Home' linkName="Dashboard" /> : null}
                                <SideLink Exact={true} imgLink='assets/svg/report.svg' linkTo='/purchaseorder' linkName="Purchase Order" />
                                <SideLink Exact={true} imgLink='assets/svg/Billing Platform.svg' linkTo='/bill' linkName="Bills" />
                                <SideLink Exact={true} imgLink='assets/svg/Billing Platform.svg' linkTo='/debit-note' linkName="Debit Note" />
                                <SideLink Exact={true} imgLink='assets/svg/payments.svg' linkTo='/payment' linkName="Payments" />
                                {/* <SideLink Exact={true} imgLink='assets/svg/report.svg' linkTo='/debitnote' linkName="Debit Note" />
                                <SideLink Exact={true} imgLink='assets/svg/report.svg' linkTo='/reports' linkName="Reports" /> */}
                                <AsideDropdown />
                            </>
                        }
                    </aside>
                </div>
            </React.Fragment>
        )
    }
}

export default Asidebar